"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bookerFilter = void 0;
const bookerFilter = (availalbePeriods, bookerPeriodsData) => {
    // 業務時間とAnd
    const bookerAvailablePeriods = bookerPeriodsData.availablePeriods.and(bookerPeriodsData.workingHours);
    return availalbePeriods.and(bookerAvailablePeriods);
};
exports.bookerFilter = bookerFilter;
//# sourceMappingURL=bookerFilter.js.map